import React from 'react';

export default function FAQ() {
  const faqs = [
    {
      question: 'Is this legit?',
      answer: 'Yes, this is a real promotion from the platform.',
    },
    {
      question: 'Why do I need ID verification?',
      answer: 'It is required by financial regulations for security.',
    },
    {
      question: 'Can I withdraw my money?',
      answer: 'Yes, your deposit remains yours and can be withdrawn.',
    },
  ];

  return (
    <section className="py-20 bg-gray-50 border-t border-gray-100">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-10">Frequently Asked Questions</h2>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h3 className="text-lg font-bold text-gray-900 mb-2">{faq.question}</h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}